module.exports = __webpack_public_path__ + "img/SKLB-informe.31882c31.png";